// extracted by mini-css-extract-plugin
export default {"logo":"LogoLink_logo__MOUkQ"};